import { __decorate, __metadata } from "tslib";
import { Component, Inject, Prop } from "vue-property-decorator";
import { SYM_LV_VALIDATOR, ValidatorInteractionState } from "./LvValidator";
import { UIComponent } from "../UIComponent";
import { ValidationMessageProvider } from "@fastoche/ui-core/validator/message/ValidationMessageProvider";
import { InjectState } from "@fastoche/ui-core/store";
import { LocalizationContext } from "@fastoche/ui-core/i18n/context";
export const COMPONENT_NAME = "LvValidationResult";
let LvValidationResult = class LvValidationResult extends UIComponent {
    constructor() {
        super(...arguments);
        this.validationMessageProvider = ValidationMessageProvider.default;
        this.validationResult = null;
    }
    mounted() {
        this.validator?.registerObserver(this.prop, this);
    }
    beforeDestroy() {
        this.validator?.unregisterObserver(this.prop, this);
    }
    /**
     * @internal
     */
    onValidationChange(validationResult) {
        this.validationResult = validationResult;
    }
    get validationState() {
        if (this.hasError) {
            return this.validator?.interactionState === ValidatorInteractionState.INITIAL ? "info" : "error";
        }
        else {
            return "success";
        }
    }
    get hasError() {
        return this.validationResult != null && Object.keys(this.validationResult).length > 0;
    }
    get firstError() {
        if (this.validationResult) {
            const firstResult = Object.entries(this.validationResult)[0];
            if (firstResult) {
                const [ruleKey] = firstResult;
                return ruleKey;
            }
        }
        return undefined;
    }
    get errorMessage() {
        const firstError = this.firstError;
        if (firstError) {
            const target = this.validator?.model?.constructor;
            if (target) {
                const propertyKey = this.prop;
                const propertyLabel = this.label ?? undefined;
                const message = this.validationMessageProvider.getValidationMessage({
                    target,
                    propertyKey,
                    propertyLabel,
                    ruleKey: firstError,
                    locale: this.localizationContext.currentLocale.langCode,
                    fallback: this.localizationContext.defaultLocale.langCode,
                });
                return message;
            }
        }
        return null;
    }
    get hasValue() {
        return (this.value !== null &&
            this.value !== undefined &&
            this.value !== "");
    }
    get value() {
        const model = this.validator?.model ?? {};
        return model[this.prop];
    }
    render(h) {
        const classes = ["lv-validation-result", `has-${this.validationState}`];
        if (this.validationResult && this.hasError) {
            return (<div class={classes}>
                    {this.errorMessage}
                </div>);
        }
        else {
            return undefined;
        }
    }
};
__decorate([
    Prop({ type: [String, Number] }),
    __metadata("design:type", Object)
], LvValidationResult.prototype, "prop", void 0);
__decorate([
    Prop({ type: String, required: false, default: null }),
    __metadata("design:type", Object)
], LvValidationResult.prototype, "label", void 0);
__decorate([
    Inject({ default: null, from: SYM_LV_VALIDATOR }),
    __metadata("design:type", Object)
], LvValidationResult.prototype, "validator", void 0);
__decorate([
    InjectState(LocalizationContext),
    __metadata("design:type", Object)
], LvValidationResult.prototype, "localizationContext", void 0);
LvValidationResult = __decorate([
    Component({
        name: COMPONENT_NAME,
    })
], LvValidationResult);
export { LvValidationResult };
export default LvValidationResult;
//# sourceMappingURL=LvValidationResult.jsx.map